import { BehaviorSubject, Observable, distinctUntilChanged, tap } from 'rxjs';
import { iStoreActions } from './store-actions.interface';
import { DirtyCheckPlugin, Queries } from '@datorama/akita';

export class DirtyChecker2 {
  isDirtySub = new BehaviorSubject(false);
  isDirty$: Observable<boolean> = this.isDirtySub.asObservable().pipe(distinctUntilChanged());
  dirtyChecker: DirtyCheckPlugin;

  constructor(
    private readonly _store: iStoreActions<any>,
    private readonly _query: Queries<any>,
  ) {
    this.dirtyChecker = new DirtyCheckPlugin(this._query);
    this.dirtyChecker.isDirty$
      .pipe(
        tap(() => {
          this.isDirtySub.next(this.isDirty());
        }),
      )
      .subscribe();
  }

  isDirty(): boolean {
    return this.dirtyChecker.isDirty() ? this.comparator(this._store.initialValue, this._query.getValue()) : false;
  }

  comparator(a, b) {
    for (const [key, updatedValue] of Object.entries(b)) {
      const initialValue = !!a && a[key] !== undefined ? a[key] : '';
      if ((updatedValue ? JSON.stringify(updatedValue) : '') !== initialValue) {
        return true;
      }
    }
    return false;
  }
}
